import { PageHero } from "@/components/primitives";
import { ArticleRows } from "@/sections/PerspectivesTeaser";
import FinalCTA from "@/sections/FinalCTA";
import { useArticles } from "@/lib/useArticles";
import { SectionShell } from "@/components/primitives";

export default function Perspectives() {
  const { articles, loading } = useArticles();
  return (
    <div data-testid="perspectives-page">
      <PageHero
        label="Perspectives"
        lines={["Ideas on building", "lasting authority."]}
        intro="An editorial view on strategic visibility, executive positioning, and the difference between attention and authority."
      />
      <SectionShell className="py-16 md:py-24">
        {loading ? (
          <p className="text-ink/50 font-body">Loading perspectives…</p>
        ) : (
          <ArticleRows articles={articles} />
        )}
      </SectionShell>
      <FinalCTA />
    </div>
  );
}
